import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';
const AuthContext = createContext(null);
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const loadUser = useCallback(async () => {
    try {
      const token = api.getToken();
      if (!token) { setLoading(false); return; }
      const cached = localStorage.getItem('rr_user');
      if (cached) setUser(JSON.parse(cached));
      const data = await api.getProfile();
      setUser(data);
      localStorage.setItem('rr_user', JSON.stringify(data));
    } catch { api.clearTokens(); setUser(null); localStorage.removeItem('rr_user'); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { loadUser(); }, [loadUser]);
  const login = async (email, password) => {
    const data = await api.login(email, password);
    setUser(data.user);
    localStorage.setItem('rr_user', JSON.stringify(data.user));
    return data;
  };
  const register = async (formData) => {
    const data = await api.register(formData);
    setUser(data.user);
    return data;
  };
  const logout = () => { api.clearTokens(); setUser(null); localStorage.removeItem('rr_user'); };
  const isAuthenticated = !!user;
  const roleList = user ? ((user.roles && user.roles.length) ? user.roles : [user.role]) : [];
  const hasRole = (r) => roleList.includes(r);
  const isSuperAdmin = hasRole('super_admin');
  const isOwner = hasRole('owner') || hasRole('super_admin');
  const isAdmin = hasRole('admin') || hasRole('super_admin');
  // Portal access is EXPLICIT — only the portals whose roles are actually assigned
  const canAdmin = roleList.some((r) => ['super_admin', 'admin', 'owner'].includes(r));
  const canManager = roleList.some((r) => ['manager', 'franchise_owner'].includes(r));
  const canStaff = hasRole('staff');
  const canClient = hasRole('customer');
  const locationRoles = user ? (user.locationRoles || []) : [];
  const globalRoles = user ? (user.globalRoles || roleList) : [];
  const isManager = canManager;
  const isStaff = canStaff;
  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, loadUser, isAuthenticated, isStaff, isManager, isAdmin, isOwner, isSuperAdmin, canAdmin, canManager, canStaff, canClient, hasRole, locationRoles, globalRoles }}>
      {children}
    </AuthContext.Provider>
  );
}
export const useAuth = () => useContext(AuthContext);
